import React from 'react';
import { PaymentOptions as PaymentOptionsIcons } from '@yme/assets/icons';
import { Image } from '@yme/atoms/image';
import { buildKey } from '@yme/utils/common';
import { PaymentOptionsLabelStyled, PaymentOptionsListStyled, PaymentOptionsStyled, } from './styled';
export function PaymentOptions({ label, paymentOptions, className, }) {
    return (React.createElement(PaymentOptionsStyled, { className: className }, paymentOptions.length > 0 && (React.createElement(React.Fragment, null,
        React.createElement(PaymentOptionsLabelStyled, null, `${label}:`),
        React.createElement(PaymentOptionsListStyled, null, paymentOptions?.map((item, index) => (React.createElement("li", { key: buildKey(item.key, index) },
            React.createElement(Image, { src: PaymentOptionsIcons[item.key], alt: item.altText })))))))));
}
PaymentOptions.displayName = 'PaymentOptions_Component';
